<template>
  <div
    class="search flex w-full justify-between gap-3 max-md:gap-2"
    :class="ui?.root"
  >
    <UInputMenu
      v-model:search-term="search"
      :placeholder="placeholder"
      class="search-input shrink-0 max-md:shrink grow"
      :class="ui?.searchInput"
      leading-icon="i-local-search"
      size="xl"
      clear
    >
      <template #empty>
        <div
          class="mr-auto ml-auto flex h-11 w-11 items-center justify-center rounded-full bg-neutral-container-light text-black"
        >
          <Icon name="i-local-search" class="h-4 w-4" />
        </div>

        <div class="mt-3 font-bold text-black">Нет данных по запросу</div>

        <UButton
          class="mt-1.75 font-medium"
          variant="link"
          color="primary"
          @click="void (search = '')"
        >
          Очистить поиск
        </UButton>
      </template>
    </UInputMenu>

    <DirectionsDropdown v-model="selectedDirections" />
  </div>
</template>

<script setup lang="ts">
import type { Direction } from '~/api'

type DirectionMenuItem = Direction & { description?: string }

defineOptions({
  name: 'SPHeroSearch',
})

const emit = defineEmits<{
  search: [value: string]
}>()

withDefaults(
  defineProps<{
    placeholder?: string
    settings?: boolean
    ui?: {
      root?: string
      searchInput?: string
      settingsButton?: string
    }
  }>(),
  {
    placeholder: 'Найти школу, тренера, направление...',
    settings: false,
    ui: () => ({}),
  },
)

const selectedDirections = ref<DirectionMenuItem[]>([])

const search = ref<string>('')

watch(search, (value) => {
  emit('search', value)
})
</script>

<style lang="scss" scoped>
:deep(.search-select) {
  min-width: 174px;
}

:deep(.select-menu) {
  [data-slot='placeholder'] {
    color: var(--color-neutral-default);
  }

  [data-slot='itemTrailing'] {
    display: none;
  }
}
</style>
